import { FC } from "react";

import { VnBadge } from "@/components/VnBadge/VnBadge";
import { VnBox } from "@/components/VnBox";
import { VnButton } from "@/components/VnButton/VnButton";
import { VnText } from "@/components/VnText/VnText";
import { I18nKeyType } from "@/i18n";
import { cn } from "@/utils/tailwind";

type ApplicationYesNoButtonPropsType = {
  onPress: () => void;
  titleI18nKey: I18nKeyType;
  descriptionI18nKey?: I18nKeyType;
  badgeI18nKey?: I18nKeyType;
  isLoading?: boolean;
  isDisabled?: boolean;
  isSelected?: boolean;
  className?: string;
};

const SELECTED_CLASSES = "border-foreground border-[1.5px]";

export const ApplicationYesNoButton: FC<ApplicationYesNoButtonPropsType> = ({
  onPress,
  titleI18nKey,
  descriptionI18nKey,
  badgeI18nKey,
  isLoading,
  isDisabled,
  isSelected,
  className,
}) => (
  <VnButton
    variant="outline"
    size="xl"
    isLoading={isLoading}
    isDisabled={isDisabled}
    iconPosition="left"
    onPress={onPress}
    // Keeps the highlighted border and the announced state from drifting apart.
    accessibilityState={{ selected: isSelected }}
    className={cn("border-border", isSelected && SELECTED_CLASSES, className)}>
    <VnBox className="w-full flex-row items-center justify-between gap-3">
      <VnBox className="flex-1 items-start">
        <VnText
          i18nKey={titleI18nKey}
          variant="lgMedium"
          className="text-start"
        />
        {descriptionI18nKey && (
          <VnText
            i18nKey={descriptionI18nKey}
            variant="lg"
            className="text-muted-foreground text-start"
          />
        )}
      </VnBox>
      {badgeI18nKey && (
        <VnBadge className="bg-sidebar border-transparent">
          <VnText i18nKey={badgeI18nKey} className="text-white" />
        </VnBadge>
      )}
    </VnBox>
  </VnButton>
);
